import React, { useEffect, useState } from "react";
import axios from "../axios";
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ParentSubQuestion = (props) => {
  // console.log(props);
  const { state } = useLocation();
  const EditEventId = state ? state.eventId : 0;
  const [Loader, setLoader] = useState(false);
  const [ParentQuestionDetails, setParentQuestionDetails] = useState([]);
  const [ParentOptionDetails, setParentOptionDetails] = useState([]);
  const [ParentQuestion, setParentQuestion] = useState(0);
  const [ParentQuestionOption, setParentQuestionOption] = useState(0);
  const [ParentQuestionError, setParentQuestionError] = useState("");
  const [ParentQuestionOptionError, setParentQuestionOptionError] = useState("");
  const [ParentGeneralFormId, setParentGeneralFormId] = useState(0);
  const [ParentFormQuestionId, setParentFormQuestionId] = useState(0);

  const [OldParentGeneralId, setOldParentGeneralId] = useState(0);
  const [OldParentFormQuestionId, setOldParentFormQuestionId] = useState(0);
  const [OldParentQuestionOptionId, setOldParentQuestionOptionId] = useState(0);

  // console.log(EditEventId, props.GeneralFormId, props.EventFormId, props.SubQuestionName);

  useEffect(() => {
    const payload = {
      event_id: EditEventId,
      event_form_question_id: props.EventFormId,
      action_flag: 'parent_question',
      edit_flag: props.ParentQuestionEdit ? props.ParentQuestionEdit : ''
    };
    axios.post("ParentSubQuestionDetails", payload)
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          setParentQuestionDetails(response.data.data.parent_question_details);
         
          const edit_details = response.data.data.edit_parent_question_details ? response.data.data.edit_parent_question_details : [];
          setParentQuestion(edit_details.edit_parent_question_id ? edit_details.edit_parent_question_id : 0);
          setParentQuestionOption(edit_details.edit_parent_option_id ? edit_details.edit_parent_option_id : 0);

          setOldParentFormQuestionId(edit_details.edit_parent_question_id ? edit_details.edit_parent_question_id : 0);
          setOldParentGeneralId(edit_details.edit_general_form_id ? edit_details.edit_general_form_id : 0);
          setOldParentQuestionOptionId(edit_details.edit_parent_option_id ? edit_details.edit_parent_option_id : 0);
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }, [])
  // console.log(ParentQuestion);

  useEffect(() => {
      if (!ParentQuestion || !ParentQuestionDetails?.length) return;
 
      const selected = ParentQuestionDetails.find(
        (item) => Number(item.id) === Number(ParentQuestion)
      );

      if (selected) {
        const optionsArray = JSON.parse(selected.question_form_option);
        // console.log("general_form_id:", selected.general_form_id);
        setParentOptionDetails(optionsArray ? optionsArray : []);
        setParentGeneralFormId(selected.general_form_id ? selected.general_form_id : 0);
        setParentFormQuestionId(selected.id ? selected.id : 0);
      }else{
        setParentOptionDetails([]);
      }
  }, [ParentQuestion, ParentQuestionDetails])

  // console.log(ParentFormQuestionId, ParentGeneralFormId, props.EventFormId, props.GeneralFormId, ParentQuestionOption);

  const handleValidation = () => {

    var flag = true;

    if (ParentQuestion === "0" || ParentQuestion === 0) {
      setParentQuestionError("Please select parent question");
      flag = false;
    } else {
      setParentQuestionError("");
    }

    if (ParentQuestionOption === "0" || ParentQuestionOption === 0) {
      setParentQuestionOptionError("Please select parent question options");
      flag = false;
    } else {
      setParentQuestionOptionError("");
    }
    return flag;
  };

  const handleSubmit = (e) => {

    e.preventDefault();
    const flag = handleValidation();
    if (flag) {
      setLoader(true);

      const formData = new FormData();
      formData.append("event_id", EditEventId ? EditEventId : 0);
      formData.append("parent_form_question_id", ParentFormQuestionId ? ParentFormQuestionId : 0);
      formData.append("parent_general_form_id", ParentGeneralFormId ? ParentGeneralFormId : 0);
      formData.append("sub_form_question_id", props.EventFormId ? props.EventFormId : 0);
      formData.append("general_form_id", props.GeneralFormId ? props.GeneralFormId : 0);
      formData.append("parent_question_options_id", ParentQuestionOption ? ParentQuestionOption : 0);
      formData.append("action_flag", "add_sub_question");
      formData.append("old_parent_general_id", OldParentGeneralId ? OldParentGeneralId : 0);
      formData.append("old_parent_form_question_id", OldParentFormQuestionId ? OldParentFormQuestionId : 0);
      formData.append("old_parent_question_option_id", OldParentQuestionOptionId ? OldParentQuestionOptionId : 0);
     
      axios.post("AddEditParentSubQuestion", formData)
        .then((response) => {
          setLoader(false);
          // console.log(response);
          if (response.status === 200) {
            props.setParentSubQuestionFlag(false);
            props.setEventFlag(true);
            toast.success(response.data.message)
          }
        })
        .catch(() => {
          setLoader(false);
          console.log('error');
        });
    }
  };


  return (
    <>

      <div className="modal is-visible w-100" data-animation="slideInUp" >
        <div className="modal-dialog quickview__main--wrapper">

          <form method="post" onSubmit={handleSubmit} encType="multipart/form-data" >
            <div className="quickview__inner">
              <div className="row">

                <div className="login__section">
                  <div className="login__section--inner" >
                    <div className="p-5">
                      <div className="account__login--header mb-25">
                        <h4 className="account__login--header__title mb-10">Add Sub Questions</h4>
                        <hr />
                      </div>

                      <div className="row">
                      
                      <div style={{paddingBottom: "70px"}}>
                        
                        <div className="col-sm-12 mb-4">
                          <div className="form-floating mb-0">
                            <input
                              type="text"
                              className="form-control"
                              placeholder=""
                              value={props.SubQuestionName}
                              disabled={true}
                            />
                            <label>Sub Question Name</label>
                          </div>
                        </div>
                        
                        <div className="col-sm-12 mb-4">
                            <div className="form-floating">
                                
                              <select className="form-control" name="filed_mapping" value={ParentQuestion} onChange={(e) => { setParentQuestion(e.target.value); }}> 
                                <option value="0">-- Select Parent Question--</option>
                
                                { ParentQuestionDetails.map((item,index) => {
                                    return (
                                      <option value={item.id} key={index}>{item.question_label}</option>
                                    )
                                }) }
                              </select>
                              <label className="form-check-label">Parent Question</label>
                              <small className="text-danger">{ParentQuestionError}</small>
                            </div>
                        </div>
                         
                        <div className="col-sm-12">
                            <div className="form-floating">
                                
                              <select className="form-control" name="filed_mapping" value={ParentQuestionOption} onChange={(e) => { setParentQuestionOption(e.target.value); }}> 
                                <option value="0">-- Select Parent Question Options --</option>
                
                                { ParentOptionDetails.map((item,index) => {
                                    return (
                                      <option value={item.id} key={index}>{item.label}</option>
                                    )
                                }) }
                              </select>
                              <label className="form-check-label">Parent Question Options</label>
                              <small className="text-danger">{ParentQuestionOptionError}</small>
                            </div>
                        </div>

                      </div>

                      <div className="d-flex gap-4">
                        <button className="account__login--btn secondary__btn mt-2" onClick={() => { props.setParentSubQuestionFlag(false); }}>Close</button>

                        <input type="submit" name="command" value="Save" className="account__login--btn primary__btn mt-2" />

                      </div>

                      </div>

                    </div>
                  </div>


                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

    </>
  );
};

export default ParentSubQuestion;
